<template>
  <b-card
    no-body
    class="card-browser-states"
  >
    <b-card-header v-if="selectedPartner">
      <div>
        <b-card-title>{{ selectedPartner.name }}</b-card-title>
        <!-- <b-card-text class="font-small-2"> Counter August 2020 </b-card-text> -->
      </div>
    </b-card-header>
    <!-- <b-card-header>
      <div>
        <b-card-title>Browser States</b-card-title>
        <b-card-text class="font-small-2"> Counter August 2020 </b-card-text>
      </div>

      <b-dropdown
        variant="link"
        no-caret
        class="chart-dropdown"
        toggle-class="p-0"
      >
        <template #button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="18"
            class="text-body cursor-pointer"
          />
        </template>
        <b-dropdown-item href="#"> Last 28 Days </b-dropdown-item>
        <b-dropdown-item href="#"> Last Month </b-dropdown-item>
        <b-dropdown-item href="#"> Last Year </b-dropdown-item>
      </b-dropdown>
    </b-card-header> -->

    <!-- body -->
    <b-card-body>
      <div
        v-for="browser in browserData"
        :key="browser.browserImg"
        class="browser-states"
      >
        <b-media no-body>
          <b-media-aside class="mr-1">
            <b-avatar
              size="30"
              variant="light-info"
            >
              <feather-icon
                size="20"
                icon="UserIcon"
              />
            </b-avatar>
          </b-media-aside>
          <b-media-body>
            <h6 class="align-self-center my-auto">
              {{ browser.name }}
            </h6>
          </b-media-body>
        </b-media>
        <div class="d-flex align-items-center">
          <span class="font-weight-bold text-body-heading mr-1">{{
            browser.usage
          }}</span>
          <!-- <vue-apex-charts
            type="radialBar"
            height="30"
            width="30"
            :options="chartData[index].options"
            :series="chartData[index].series"
          /> -->
        </div>
      </div>
    </b-card-body>
    <!--/ body -->
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BMedia,
  BMediaAside,
  BMediaBody,
  BImg,
  BDropdown,
  BDropdownItem,
  BAvatar,
} from 'bootstrap-vue';
import VueApexCharts from 'vue-apexcharts';
import { $themeColors } from '@themeConfig';
/* eslint-disable global-require */
const $trackBgColor = '#e9ecef';
export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BMediaAside,
    BMediaBody,
    BImg,
    BDropdown,
    BDropdownItem,
    VueApexCharts,
    BAvatar,
  },
  props: {
    userStatistics: {
      type: Object,
      default: () => ({
        activeUsers: 0,
        newUsers: 0,
        totalUsers: 0,
      }),
    },
    selectedPartner: {
      type: Object | null,
    },
  },
  computed: {
    browserData() {
      return [
        {
          browserImg: require('@/assets/images/icons/google-chrome.png'),
          name: 'Active Visitors',
          usage: this.userStatistics?.activeUsers || 0,
        },
        {
          browserImg: require('@/assets/images/icons/mozila-firefox.png'),
          name: 'New Visitors',
          usage: this.userStatistics?.newUsers || 0,
        },
        {
          browserImg: require('@/assets/images/icons/apple-safari.png'),
          name: 'Average Active Visitors',
          usage: this.userStatistics?.totalUsers || 0,
        },
      ];
    },
  },
  data() {
    return {};
  },
  created() {},
};
</script>
